module.exports = __webpack_public_path__ + "static/media/shreearts.9d7d3647.PNG";